import { get } from 'lodash-es';

const byIsLoading = (state: any) => get(state, 'resultList.isLoading');

export default byIsLoading;
